import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as Enums from '../enums/enums';
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

/*
  Generated class for the BeerHiveButtonProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({
    providedIn: 'root'
})
export class BeerHiveButtonProvider {
  private buttonTemplate: Array<any>;

  constructor(public http: HttpClient, private bhutil: BhutilProvider, private translateService: TranslateService) {
    console.log('Hello BeerHiveButtonProvider Provider');
    translateService.stream('BUTTONS.MOUTHFEEL').subscribe((res:string) => {
    this.buttonTemplate = [

      /*{
        svgPath: "assets/svg/icon_sight.svg",
        buttons: [
          {
            svgPath: "assets/svg/icon_sight_colour.svg",
            type: Enums.ButtonTypes.COLOR_PARENT,
            colors: ["#FFFFCD", "#FFFF01", "#FE9900", "#A94124", "#5B220E", "#FFC000", "#CC6601", "#CC0001", "#080808"],
            selected: false,
            label : "colour",
            key : "colour"
          },
          {
            svgPath: "assets/svg/icon_sight_clarity.svg",
            colors: ["#FFFFFF", "#DDDDDD", "#BBBBBB", "#999999", "#777777"],
            type: Enums.ButtonTypes.COLOR_PARENT,
            selected: false,
            label : "clarity",
            key : "clarity"
          },
          {
            svgPath: "assets/svg/icon_sight_head.svg",
            type: Enums.ButtonTypes.ONE_TO_FIVE_PARENT,
            selected: false,
            label:"head",
            key:"head"
          },
          {
            svgPath: "assets/svg/icon_sight_CO2.svg",
            type: Enums.ButtonTypes.ONE_TO_FIVE_PARENT,
            selected: false,
            label:"CO2",
            key:"CO2"
          }
        ],
        selected: true,
        type: Enums.ButtonTypes.PARENT
      },*/
      /*{
        svgPath: "assets/svg/icon_taste.svg",
        selected: false,
        type: Enums.ButtonTypes.PARENT,
        buttons: [
          {
            svgPath: "assets/svg/icon_taste_sweet.svg",
            type: Enums.ButtonTypes.ONE_TO_FIVE_PARENT,
            selected: false,
            label:"sweet",
            key:"sweet"
          },
          {
            svgPath: "assets/svg/icon_taste_sour.svg",
            type: Enums.ButtonTypes.ONE_TO_FIVE_PARENT,
            selected: false,
            label:"sour",
            key:"sour"
          },
          {
            svgPath: "assets/svg/icon_taste_bitter.svg",
            type: Enums.ButtonTypes.ONE_TO_FIVE_PARENT,
            selected: false,
            label:"bitter",
            key: "bitter"
          },
          {
            svgPath: "assets/svg/icon_taste_salty.svg",
            type: Enums.ButtonTypes.ONE_TO_FIVE_PARENT,
            selected: false,
            label:"salty",
            key:"salty"
          }
        ],

      },*/
      {
        svgPath: "assets/svg/icon_mouthfeel.svg",
        label: this.translateService.instant('BUTTONS.MOUTHFEEL'),
        selected: false,
        buttons: [
          {
            svgPath: "assets/svg/icon_mouthfeel_intensity.svg",
            type: Enums.ButtonTypes.ONE_TO_FIVE_PARENT,
            selected: false,
            label: this.translateService.instant('BUTTONS.INTENSITY'),
            key: "intensity"

          },
          {
            svgPath: "assets/svg/icon_mouthfeel_body.svg",
            type: Enums.ButtonTypes.ONE_TO_FIVE_PARENT,
            selected: false,
            label: this.translateService.instant('BUTTONS.BODY'),
            key: "body"
          },
          {
            svgPath: "assets/svg/icon_mouthfeel_astringency.svg",
            type: Enums.ButtonTypes.ONE_TO_FIVE_PARENT,
            selected: false,
            label: this.translateService.instant('BUTTONS.ASTRINGENT'),
            key: "astringent"
          },
          {
            svgPath: "assets/svg/icon_mouthfeel_alcohol.svg",
            type: Enums.ButtonTypes.ONE_TO_FIVE_PARENT,
            selected: false,
            label: this.translateService.instant('BUTTONS.ALCOHOL'),
            key: "alcohol"
          },
          {
            svgPath: "assets/svg/icon_mouthfeel_carbonation.svg",
            type: Enums.ButtonTypes.ONE_TO_FIVE_PARENT,
            selected: false,
            label: this.translateService.instant('BUTTONS.CARBONATION'),
            key: "carbonation"
          }
        ],
        type: Enums.ButtonTypes.PARENT
      },
      {
        svgPath: "assets/svg/icon_aroma.svg",
        label: this.translateService.instant('BUTTONS.AROMAS'),
        selected: false,
        type: Enums.ButtonTypes.PARENT,
        buttons: [
          {
            svgPath: "assets/svg/icon_aroma_malty.svg",
            label: this.translateService.instant('BUTTONS.MALTY'),
            type: Enums.ButtonTypes.BINARY_ONLY,
            selected: false,
            detailsButton: {
              svgPath: "assets/svg/icon_details_2.svg",
              type: Enums.ButtonTypes.DETAILS_BUTTON
            },
            detailsChildren: [
              {
                svgPath: "assets/svg/icon_aroma_malty_malt.svg",
                label: this.translateService.instant('BUTTONS.MALT'),
                key: "malty_malt"
              },
              {
                svgPath: "assets/svg/icon_aroma_malty_cereal.svg",
                label: this.translateService.instant('BUTTONS.CEREAL'),
                key: "malty_cereal"
              }, {
                svgPath: "assets/svg/icon_aroma_malty_coffee.svg",
                label: this.translateService.instant('BUTTONS.COFFEE'),
                key: "malty_coffee"
              }, {
                svgPath: "assets/svg/icon_aroma_malty_tobacco.svg",
                label: this.translateService.instant('BUTTONS.TOBACCO'),
                key: "malty_tobacco"
              }, {
                svgPath: "assets/svg/icon_aroma_malty_bread.svg",
                label: this.translateService.instant('BUTTONS.BREAD'),
                key: "malty_bread"
              }, {
                svgPath: "assets/svg/icon_aroma_malty_wheat.svg",
                label: this.translateService.instant('BUTTONS.WHEAT'),
                key: "malty_wheat"
              }, {
                svgPath: "assets/svg/icon_aroma_malty_chocolate.svg",
                label: this.translateService.instant('BUTTONS.CHOCOLATE'),
                key: "malty_chocolate"
              }, {
                svgPath: "assets/svg/icon_aroma_malty_roasted.svg",
                label: this.translateService.instant('BUTTONS.ROASTED'),
                key: "malty_roasted"
              }, {
                svgPath: "assets/svg/icon_aroma_malty_peat.svg",
                label: this.translateService.instant('BUTTONS.PEAT'),
                key: "malty_peat"
              }, {
                svgPath: "assets/svg/icon_aroma_malty_toast.svg",
                label: this.translateService.instant('BUTTONS.TOAST'),
                key: "malty_toast"
              }, {
                svgPath: "assets/svg/icon_aroma_malty_caramel.svg",
                label: this.translateService.instant('BUTTONS.CARAMEL'),
                key: "malty_caramel"
              }, {
                svgPath: "assets/svg/icon_aroma_malty_burnt.svg",
                label: this.translateService.instant('BUTTONS.BURNT'),
                key: "malty_burnt"
              }, {
                svgPath: "assets/svg/icon_aroma_malty_smoked.svg",
                label: this.translateService.instant('BUTTONS.SMOKED'),
                key: "malty_smoked"
              }, {
                svgPath: "assets/svg/icon_aroma_malty_biscuit.svg",
                label: this.translateService.instant('BUTTONS.BISCUIT'),
                key: "malty_biscuit"
              }, {
                svgPath: "assets/svg/icon_aroma_malty_toffee.svg",
                label: this.translateService.instant('BUTTONS.TOFFEE'),
                key: "malty_toffee"
              }, {
                svgPath: "assets/svg/icon_aroma_malty_brownsugar.svg",
                label: this.translateService.instant('BUTTONS.BROWNSUGAR'),
                key: "malty_brownsugar"
              }, {
                svgPath: "assets/svg/icon_aroma_malty_tar.svg",
                label: this.translateService.instant('BUTTONS.TAR'),
                key: "malty_tar"
              }, {
                svgPath: "assets/svg/icon_aroma_malty_ashes.svg",
                label: this.translateService.instant('BUTTONS.ASHES'),
                key: "malty_ashes"
              }
            ],
            largeRow: 5,
            smallRow: 4,
            startY: 0.5,
            startWithLargeRow: false
          },
          {
            svgPath: "assets/svg/icon_aroma_fruity.svg",
            label: this.translateService.instant('BUTTONS.FRUITY'),
            type: Enums.ButtonTypes.BINARY_ONLY,
            selected: false,
            detailsButton: {
              svgPath: "assets/svg/icon_details_2.svg",
              type: Enums.ButtonTypes.DETAILS_BUTTON
            },
            detailsChildren: [
              {
                svgPath: "assets/svg/icon_aroma_fruity_lemon.svg",
                key: "fruity_lemon",
                label: this.translateService.instant('BUTTONS.LEMON')
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_banana.svg",
                key: "fruity_banana",
                label: this.translateService.instant('BUTTONS.BANANA')
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_apple.svg",
                label: this.translateService.instant('BUTTONS.GREENAPPLE'),
                key: "fruity_greenapple"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_peach.svg",
                label: this.translateService.instant('BUTTONS.PEACH'),
                key: "fruity_peach"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_cherry.svg",
                label: this.translateService.instant('BUTTONS.CHERRY'),
                key: "fruity_cherry"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_raspberry.svg",
                label: this.translateService.instant('BUTTONS.RASPBERRY'),
                key: "fruity_raspberry"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_strawberry.svg",
                label: this.translateService.instant('BUTTONS.STRAWBERRY'),
                key: "fruity_strawberry"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_lime.svg",
                label: this.translateService.instant('BUTTONS.LIME'),
                key: "fruity_lime"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_pineapple.svg",
                label: this.translateService.instant('BUTTONS.PINEAPPLE'),
                key: "fruity_pineapple"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_apple.svg",
                label: this.translateService.instant('BUTTONS.REDAPPLE'),
                key: "fruity_redapple"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_apricot.svg",
                label: this.translateService.instant('BUTTONS.APRICOT'),
                key: "fruity_apricot"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_cherry.svg",
                label: this.translateService.instant('BUTTONS.WILDCHERRY'),
                key: "fruity_wildcherry"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_blueberry.svg",
                label: this.translateService.instant('BUTTONS.BLUEBERRY'),
                key: "fruity_blueberry"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_raspberry.svg",
                label: this.translateService.instant('BUTTONS.BLACKBERRY'),
                key: "fruity_blackberry"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_grapefruit.svg",
                label: this.translateService.instant('BUTTONS.GRAPEFRUIT'),
                key: "fruity_grapefruit"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_passionfruit.svg",
                label: this.translateService.instant('BUTTONS.PASSIONFRUIT'),
                key: "fruity_passionfruit"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_pomegranate.svg",
                label: this.translateService.instant('BUTTONS.POMEGRANATE'),
                key: "fruity_pomegranate"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_pear.svg",
                label: this.translateService.instant('BUTTONS.PEAR'),
                key: "fruity_pear"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_plum.svg",
                label: this.translateService.instant('BUTTONS.PLUM'),
                key: "fruity_plum"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_blackcurrant.svg",
                label: this.translateService.instant('BUTTONS.BLACKCURRANT'),
                key: "fruity_blackcurrant"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_grape.svg",
                label: this.translateService.instant('BUTTONS.GRAPE'),
                key: "fruity_grape"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_orange.svg",
                label: this.translateService.instant('BUTTONS.ORANGE'),
                key: "fruity_orange"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_mango.svg",
                label: this.translateService.instant('BUTTONS.MANGO'),
                key: "fruity_mango"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_lychee.svg",
                label: this.translateService.instant('BUTTONS.LYCHEE'),
                key: "fruity_lychee"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_fig.svg",
                label: this.translateService.instant('BUTTONS.FIG'),
                key: "fruity_fig"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_prune.svg",
                label: this.translateService.instant('BUTTONS.PRUNE'),
                key: "fruity_prune"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_date.svg",
                label: this.translateService.instant('BUTTONS.DATE'),
                key: "fruity_date"
              }, {
                svgPath: "assets/svg/icon_aroma_fruity_raisin.svg",
                label: this.translateService.instant('BUTTONS.RAISIN'),
                key: "fruity_raisin"
              },

            ],
            largeRow: 7,
            smallRow: 7,
            startY: -0.5,
            startWithLargeRow: false
          },
          {
            svgPath: "assets/svg/icon_aroma_hoppy.svg",
            label: this.translateService.instant('BUTTONS.HOPPY'),
            type: Enums.ButtonTypes.BINARY_ONLY,
            selected: false,
            detailsButton: {
              svgPath: "assets/svg/icon_details_2.svg",
              type: Enums.ButtonTypes.DETAILS_BUTTON
            },
            detailsChildren: [
              {
                svgPath: "assets/svg/icon_aroma_hoppy_fresh.svg",
                label: this.translateService.instant('BUTTONS.FRESH'),
                key: "hoppy_fresh"
              }, {
                svgPath: "assets/svg/icon_aroma_hoppy_old.svg",
                label: this.translateService.instant('BUTTONS.OLD'),
                key: "hoppy_old"
              }, {
                svgPath: "assets/svg/icon_aroma_hoppy_grassy.svg",
                label: this.translateService.instant('BUTTONS.GRASSY'),
                key: "hoppy_grassy"
              }, {
                svgPath: "assets/svg/icon_aroma_hoppy_straw.svg",
                label: this.translateService.instant('BUTTONS.STRAW'),
                key: "hoppy_straw"
              },
            ],
            largeRow: 2,
            smallRow: 1,
            startY: .5,
            startWithLargeRow: false
          },
          {
            svgPath: "assets/svg/icon_aroma_spices.svg",
            label: this.translateService.instant('BUTTONS.SPICES'),
            type: Enums.ButtonTypes.BINARY_ONLY,
            selected: false,

            detailsButton: {
              svgPath: "assets/svg/icon_details_2.svg",
              type: Enums.ButtonTypes.DETAILS_BUTTON
            },
            detailsChildren: [
              //kolom 1
              {
                svgPath: "assets/svg/icon_aroma_spices_nuts.svg",
                label: this.translateService.instant('BUTTONS.NUTS'),
                key: "spices_nuts"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_clove.svg",
                label: this.translateService.instant('BUTTONS.CLOVE'),
                key: "spices_clove"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_coriander.svg",
                label: this.translateService.instant('BUTTONS.CORIANDER'),
                key: "spices_coriander"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_vanilla.svg",
                label: this.translateService.instant('BUTTONS.VANILLA'),
                key: "spices_vanilla"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_honey.svg",
                label: this.translateService.instant('BUTTONS.HONEY'),
                key: "spices_honey"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_maplesyrup.svg",
                label: this.translateService.instant('BUTTONS.MAPLESYRUP'),
                key: "spices_maplesyrup"
              },
              //kolom 2
              {
                svgPath: "assets/svg/icon_aroma_spices_coconut.svg",
                label: this.translateService.instant('BUTTONS.COCONUT'),
                key: "spices_coconut"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_almond.svg",
                label: this.translateService.instant('BUTTONS.ALMOND'),
                key: "spices_almond"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_juniper.svg",
                label: this.translateService.instant('BUTTONS.JUNIPER'),
                key: "spices_juniper"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_cinnamon.svg",
                label: this.translateService.instant('BUTTONS.CINNAMON'),
                key: "spices_cinnamon"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_eucalyptus.svg",
                label: this.translateService.instant('BUTTONS.EUCALYPTUS'),
                key: "spices_eucalyptus"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_elderflower.svg",
                label: this.translateService.instant('BUTTONS.ELDERFLOWER'),
                key: "spices_elderflower"
              },
              //kolom 3
              {
                svgPath: "assets/svg/icon_aroma_spices_nutmeg.svg",
                label: this.translateService.instant('BUTTONS.NUTMEG'),
                key: "spices_nutmeg"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_ginger.svg",
                label: this.translateService.instant('BUTTONS.GINGER'),
                key: "spices_ginger"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_mint.svg",
                label: this.translateService.instant('BUTTONS.MINT'),
                key: "spices_mint"
              }, {
                svgPath: "assets/svg/icon_aroma_spices_orangezest.svg",
                label: this.translateService.instant('BUTTONS.ORANGEZEST'),
                key: "spices_orangezest"
              }, {
                svgPath: "assets/svg/icon_aroma_spices_lemongrass.svg",
                label: this.translateService.instant('BUTTONS.LEMONGRASS'),
                key: "spices_lemongrass"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_floral.svg",
                label: this.translateService.instant('BUTTONS.FLORAL'),
                key: "spices_floral"
              },
              //kolom 4
              {
                svgPath: "assets/svg/icon_aroma_spices_salt.svg",
                label: this.translateService.instant('BUTTONS.SALT'),
                key: "spices_salt"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_pepper.svg",
                label: this.translateService.instant('BUTTONS.PEPPER'),
                key: "spices_pepper"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_chili.svg",
                label: this.translateService.instant('BUTTONS.CHILI'),
                key: "spices_chili"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_anise.svg",
                label: this.translateService.instant('BUTTONS.ANISE'),
                key: "spices_anise"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_liquorice.svg",
                label: this.translateService.instant('BUTTONS.LIQUORICE'),
                key: "spices_liquorice"
              },
              {
                svgPath: "assets/svg/icon_aroma_spices_tea.svg",
                label: this.translateService.instant('BUTTONS.TEA'),
                key: "spices_tea"
              }
            ],
            largeRow: 6,
            smallRow: 6,
            startY: -2.5,
            startWithLargeRow: false
          },
          {
            svgPath: "assets/svg/icon_aroma_animal.svg",
            label: this.translateService.instant('BUTTONS.ANIMAL'),
            type: Enums.ButtonTypes.BINARY_ONLY,
            selected: false,

            detailsButton: {
              svgPath: "assets/svg/icon_details_2.svg",
              type: Enums.ButtonTypes.DETAILS_BUTTON
            },
            detailsChildren: [
              //kolom 1
              {
                svgPath: "assets/svg/icon_aroma_animal_butter.svg",
                label: this.translateService.instant('BUTTONS.BUTTER'),
                key: "animal_butter"
              },
              {
                svgPath: "assets/svg/icon_aroma_animal_yeast.svg",
                label: this.translateService.instant('BUTTONS.YEAST'),
                key: "animal_yeast"
              },
              {
                svgPath: "assets/svg/icon_aroma_animal_earth.svg",
                label: this.translateService.instant('BUTTONS.EARTH'),
                key: "animal_earth"
              },
              //kolom 2
              {
                svgPath: "assets/svg/icon_aroma_animal_oldbutter.svg",
                label: this.translateService.instant('BUTTONS.OLDBUTTER'),
                key: "animal_oldbutter"
              },
              {
                svgPath: "assets/svg/icon_aroma_animal_wildyeast.svg",
                label: this.translateService.instant('BUTTONS.WILDYEAST'),
                key: "animal_wildyeast"
              },
              {
                svgPath: "assets/svg/icon_aroma_animal_leather.svg",
                label: this.translateService.instant('BUTTONS.LEATHER'),
                key: "animal_leather"
              },
              //kolom 3
              {
                svgPath: "assets/svg/icon_aroma_animal_yoghurt.svg",
                label: this.translateService.instant('BUTTONS.YOGHURT'),
                key: "animal_yoghurt"
              },
              {
                svgPath: "assets/svg/icon_aroma_animal_barnyard.svg",
                label: this.translateService.instant('BUTTONS.BARNYARD'),
                key: "animal_barnyard"
              },
              {
                svgPath: "assets/svg/icon_aroma_animal_wetgoat.svg",
                label: this.translateService.instant('BUTTONS.WETGOAT'),
                key: "animal_wetgoat"
              },
              //kolom 4
              {
                svgPath: "assets/svg/icon_aroma_animal_cheese.svg",
                label: this.translateService.instant('BUTTONS.CHEESE'),
                key: "animal_cheese"
              },
              {
                svgPath: "assets/svg/icon_aroma_animal_oyster.svg",
                label: this.translateService.instant('BUTTONS.OYSTER'),
                key: "animal_oyster"
              }
            ],
            largeRow: 3,
            smallRow: 3,
            startY: -1.5,
            startWithLargeRow: true
          },
          {
            svgPath: "assets/svg/icon_aroma_wood.svg",
            label: this.translateService.instant('BUTTONS.WOOD'),
            type: Enums.ButtonTypes.BINARY_ONLY,
            selected: false,

            detailsButton: {
              svgPath: "assets/svg/icon_details_2.svg",
              type: Enums.ButtonTypes.DETAILS_BUTTON
            },
            detailsChildren: [
              {
                svgPath: "assets/svg/icon_aroma_wood_oak.svg",
                label: this.translateService.instant('BUTTONS.OAK'),
                key: "wood_oak"
              },
              {
                svgPath: "assets/svg/icon_aroma_wood_pine.svg",
                label: this.translateService.instant('BUTTONS.PINE'),
                key: "wood_pine"
              },
              {
                svgPath: "assets/svg/icon_aroma_wood_cognac.svg",
                label: this.translateService.instant('BUTTONS.COGNAC'),
                key: "wood_cognac"
              },
              {
                svgPath: "assets/svg/icon_aroma_wood_wine.svg",
                label: this.translateService.instant('BUTTONS.WINE'),
                key: "wood_wine"
              },
              {
                svgPath: "assets/svg/icon_aroma_wood_resinous.svg",
                label: this.translateService.instant('BUTTONS.RESINOUS'),
                key: "wood_resinous"
              },
              {
                svgPath: "assets/svg/icon_aroma_wood_whiskey.svg",
                label: this.translateService.instant('BUTTONS.WHISKEY'),
                key: "wood_whiskey"
              },
              {
                svgPath: "assets/svg/icon_aroma_wood_port.svg",
                label: this.translateService.instant('BUTTONS.PORT'),
                key: "wood_port"
              },
              {
                svgPath: "assets/svg/icon_aroma_wood_calvados.svg",
                label: this.translateService.instant('BUTTONS.CALVADOS'),
                key: "wood_calvados"
              },
              {
                svgPath: "assets/svg/icon_aroma_wood_sherry.svg",
                label: this.translateService.instant('BUTTONS.SHERRY'),
                key: "wood_sherry"
              },
              {
                svgPath: "assets/svg/icon_aroma_wood_madeira.svg",
                label: this.translateService.instant('BUTTONS.MADEIRA'),
                key: "wood_madeira"
              }
            ],
            largeRow: 3,
            smallRow: 2,
            startY: -.5,
            startWithLargeRow: false
          },
          {
            svgPath: "assets/svg/icon_aroma_misc.svg",
            label: this.translateService.instant('BUTTONS.MISC'),
            type: Enums.ButtonTypes.BINARY_ONLY,
            selected: false,

            detailsButton: {
              svgPath: "assets/svg/icon_details_2.svg",
              type: Enums.ButtonTypes.DETAILS_BUTTON
            },
            detailsChildren: [
              //3
              {
                svgPath: "assets/svg/icon_aroma_misc_oxidated.svg",
                label: this.translateService.instant('BUTTONS.OXIDATED'),
                key: "misc_oxidated"
              },
              {
                svgPath: "assets/svg/icon_aroma_misc_paper.svg",
                label: this.translateService.instant('BUTTONS.PAPER'),
                key: "misc_paper"
              },
              {
                svgPath: "assets/svg/icon_aroma_misc_metallic.svg",
                label: this.translateService.instant('BUTTONS.METALLIC'),
                key: "misc_metallic"
              },
              //4
              {
                svgPath: "assets/svg/icon_aroma_misc_mineral.svg",
                label: this.translateService.instant('BUTTONS.MINERAL'),
                key: "misc_mineral"
              },
              {
                svgPath: "assets/svg/icon_aroma_misc_chalk.svg",
                label: this.translateService.instant('BUTTONS.CHALK'),
                key: "misc_chalk"
              },
              {
                svgPath: "assets/svg/icon_aroma_misc_glue.svg",
                label: this.translateService.instant('BUTTONS.GLUE'),
                key: "misc_glue"
              },
              {
                svgPath: "assets/svg/icon_aroma_misc_solvent.svg",
                label: this.translateService.instant('BUTTONS.SOLVENT'),
                key: "misc_solvent"
              },
              //3
              {
                svgPath: "assets/svg/icon_aroma_misc_medicinal.svg",
                label: this.translateService.instant('BUTTONS.MEDICINAL'),
                key: "misc_medicinal"
              },
              {
                svgPath: "assets/svg/icon_aroma_misc_skunk.svg",
                label: this.translateService.instant('BUTTONS.SKUNK'),
                key: "misc_skunk"
              },
              {
                svgPath: "assets/svg/icon_aroma_misc_match.svg",
                label: this.translateService.instant('BUTTONS.MATCH'),
                key: "misc_match"
              },
              //4
              {
                svgPath: "assets/svg/icon_aroma_misc_vinegar.svg",
                label: this.translateService.instant('BUTTONS.VINEGAR'),
                key: "misc_vinegar"
              },
              {
                svgPath: "assets/svg/icon_aroma_misc_soap.svg",
                label: this.translateService.instant('BUTTONS.SOAP'),
                key: "misc_soap"
              },
              {
                svgPath: "assets/svg/icon_aroma_misc_cookedcorn.svg",
                label: this.translateService.instant('BUTTONS.COOKEDCORN'),
                key: "misc_cookedcorn"
              },
              {
                svgPath: "assets/svg/icon_aroma_misc_egg.svg",
                label: this.translateService.instant('BUTTONS.EGG'),
                key: "misc_egg"
              }
            ],
            largeRow: 4,
            smallRow: 3,
            startY: -2.5,
            startWithLargeRow: false
          }
        ],
      }];
    });
  }
  public getButtons(): Array<any> {
    return this.bhutil.createCopy(this.buttonTemplate);
  }

}
